import type { IUserMe, IUserPublic } from '~/types/user'

import config from '~/config'
import { request } from '~/utils/request'

export const getConnectedUsersCount = (): Promise<{ count: number }> => {
  return request<{ count: number }>({
    url: `${config.AUTHENTICATION_API}/user/last-access/count`,
  })
}

export const getMeAsUser = (): Promise<IUserMe> => {
  return request({
    url: `${config.AUTHENTICATION_API}/me`,
  })
}

export const getUser = (id: string): Promise<IUserPublic> => {
  return request({
    url: `${config.AUTHENTICATION_API}/user/${id}`,
  })
}

export const getUsers = (): Promise<IUserPublic[]> => {
  return request({
    url: `${config.AUTHENTICATION_API}/user`,
  })
}
